import { useCallback, useEffect, useRef, useState } from 'react'
import {
    apiAuditLogGetByTranId,
    apiCheckDataCode,
    apiCheckDataCodeOnDataSponsor,
    apiGetCheckTransaction,
    apiGetCheckTransactionOnDataSponsor,
    apiGetCheckTransactionOnVTVCab,
    apiGetListPartner,
    apiGetTransactionRefund,
    apiRefundTransaction
} from '../../api'
import { CheckDataCodeResponse, CheckTransactionResponse } from '../../interfaces/transactions.interface'
import { Button, DatePicker, type DatePickerProps, Modal, Space, Tabs, TabsProps, Card, Row, Col, Typography, Divider, Timeline, Tag, message, Collapse } from 'antd'
import { PartnerList } from '../../interfaces/list-partner.interface';
import { useLoading } from '../../context/LoadingContext';
import { Select, Input } from 'antd';
import { toast } from 'react-toastify';
import { toastError, toastSuccess } from '../../utils/toast';
import dayjs, { Dayjs } from "dayjs";
import defaultParams from "../../assets/constants/default_params";
import { mapCompanyAccounts } from '../../assets/constants/constants';
import { TeamOutlined, TransactionOutlined, GiftOutlined, ReloadOutlined, ClockCircleOutlined, CheckCircleOutlined, CopyOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { formatCurrency } from '../../utils/string-utils';
import JsonView from 'react18-json-view'
import 'react18-json-view/src/style.css'

const { Title, Text } = Typography;

const initCusgomer = {
    partners: [],
    total: 0
}

export default function TransactionOverview() {
    const [customers, setCustomers] = useState<PartnerList>(initCusgomer)
    const [data, setData] = useState<CheckTransactionResponse>();
    const [selectedCustomer, setSelectedCustomer] = useState<number>(0);
    const [tranId, setTranId] = useState('');
    const [dataCheck, setDataCheck] = useState<any>({});
    const selectRef = useRef(null);
    const [dataCode, setDataCode] = useState<CheckDataCodeResponse>();
    const [selectedCustomerDataCode, setSelectedCustomerCode] = useState<number>(0);
    const [dataCodeSerial, setDataCodeSerial] = useState('');
    const selectCodeRef = useRef(null);
    const [tranRefund, setTranRefund] = useState<any>({
        total: 0,
        listTrans: [],
    });
    const [selectedCustomerDataRefund, setSelectedCustomerRefund] = useState<number>(0);
    const selectRefundRef = useRef(null);
    const [modalSponsor, setModalSponsor] = useState<{ data: any, isOpen: boolean }>({
        data: null,
        isOpen: false,
    })
    const [cofirmCode, setConfirmCode] = useState<string>('')
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [resultOnDataSponsor, setResultOnDataSponsor] = useState('')
    const [auditLogs, setAuditLogs] = useState<any>([])
    const [timeRefund, setTimeRefund] = useState<any>();

    useEffect(() => {
        const now = new Date()
        const year = now.getFullYear()
        const month = now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1
        setTimeRefund(dayjs(`${year}-${month}`, 'YYYY-MM'))
    }, [])

    const { setIsLoading } = useLoading();

    useEffect(() => {
        fetchApiGetListPartner()
    }, [])

    async function fetchTransactions(cpCode: string, tranId: string) {
        try {
            const date = new Date();
            const resTransactions = await apiGetCheckTransaction({
                cpCode: cpCode,
                tranId: tranId,
                reqTime: date.getTime(),
                date: selectedDate.format(defaultParams.FORMAT_DATE),
            })
            console.log('resTransactions', resTransactions);
            if (!resTransactions?.data?.listTrans || resTransactions?.data?.listTrans?.length <= 0) {
                toast.success('Không có kết quả trả về!')
                return setData({
                    tranId: '',
                    return: '',
                    description: '',
                    detailCode: '',
                    total: 0,
                    listTrans: [],
                })
            }
            return setData(resTransactions.data)
        } catch (error) {
            console.log('error', error);
            toast.error('Có lỗi xảy ra!')
            setData({
                tranId: '',
                return: '',
                description: '',
                detailCode: '',
                total: 0,
                listTrans: [],
            })
        }
    }

    async function fetchTransactionsOnDataDataSponsor(cpCode: string, tranId: string, reqTime: string, type?: string) {
        try {
            setResultOnDataSponsor('')
            setAuditLogs([])
            const date = new Date();
            if (type === "REGISTER_COMBO_PROMOTION" || type === "REGISTER_SERVICE") {
                const resVTVCab = await apiGetCheckTransactionOnVTVCab({
                    cpCode: cpCode,
                    tranId: tranId,
                    reqTime: date.getTime(),
                    date: reqTime,
                })
                console.log('resVTVCab', resVTVCab);
                if (!resVTVCab.data?.result) {
                    toast.success('Không có kết quả trả về!')
                    return setResultOnDataSponsor('')
                }
                const respAuditLog = await apiAuditLogGetByTranId({ tran_id: tranId, audit_log_type: 'DATASPONSOR' })
                if (!respAuditLog.data?.audit_logs) {
                    toast.error('Không có kết quả audit log trả về!')
                    setAuditLogs([])
                }
                setResultOnDataSponsor(resVTVCab.data?.result)
                setAuditLogs(respAuditLog.data?.audit_logs)
                return
            }
            const resTransactions = await apiGetCheckTransactionOnDataSponsor({
                cpCode: cpCode,
                tranId: tranId,
                reqTime: date.getTime(),
                date: reqTime,
            })
            console.log('resTransactions', resTransactions);
            if (!resTransactions.data?.result) {
                toast.error('Không có kết quả trả về!')
                setResultOnDataSponsor('')
            }

            const respAuditLog = await apiAuditLogGetByTranId({ tran_id: tranId, audit_log_type: 'DATASPONSOR' })
            if (!respAuditLog.data?.audit_logs) {
                toast.error('Không có kết quả audit log trả về!')
                setAuditLogs([])
            }
            setResultOnDataSponsor(resTransactions.data.result)
            setAuditLogs(respAuditLog.data?.audit_logs)
        } catch (error) {
            console.log('error', error);
            toast.error('Vui lòng kiểm tra lại thông tin')
            setResultOnDataSponsor('')
            setAuditLogs([])
        }
    }

    async function fetchDataCodeOnDataDataSponsor(cpCode: string, dataCodeSerial: string, tranId: string) {
        try {
            setResultOnDataSponsor('')
            setAuditLogs([])
            const date = new Date();
            const resTransactions = await apiCheckDataCodeOnDataSponsor({
                cpCode: cpCode,
                dataCodeSerial: dataCodeSerial,
                reqTime: date.getTime(),
                date: selectedDate.format(defaultParams.FORMAT_DATE),
            })
            console.log('resTransactions', resTransactions);
            if (!resTransactions.data?.result) {
                toast.error('Không có kết quả trả về!')
                return setResultOnDataSponsor('')
            }

            const respAuditLog = await apiAuditLogGetByTranId({ tran_id: tranId, audit_log_type: 'DATACODE' })
            if (!respAuditLog.data?.audit_logs) {
                toast.error('Không có kết quả audit log trả về!')
                setAuditLogs([])
            }
            setResultOnDataSponsor(resTransactions.data.result)
            setAuditLogs(respAuditLog.data?.audit_logs)
            return
        } catch (error) {
            console.log('error', error);
            toast.error('Có lỗi xảy ra!')
            setResultOnDataSponsor('')
            setAuditLogs([])
        }
    }

    async function fetchDataCode(cpCode: string, tranIdCode: string) {
        try {
            const date = new Date();
            const resDataCodes = await apiCheckDataCode({
                cpCode: cpCode,
                dataCodeSerial: tranIdCode,
                reqTime: date.getTime(),
                date: selectedDate.format(defaultParams.FORMAT_DATE),
            })
            console.log('resDataCodes', resDataCodes);
            if (!resDataCodes.data?.dataCodeModels || resDataCodes.data?.dataCodeModels?.length <= 0) {
                toast.success('Không có kết quả trả về!')
                return setDataCode({
                    total: 0,
                    dataCodeModels: [],
                })
            }
            return setDataCode(resDataCodes.data)
        } catch (error) {
            console.log('error', error);
            toast.error('Có lỗi xảy ra!')
            setDataCode({
                total: 0,
                dataCodeModels: [],
            })
        }
    }

    async function fetchTranRefund(cpCode: string, year: number, month: number) {
        try {
            const respTranRefund = await apiGetTransactionRefund({ cpCode, year, month })
            console.log('respTranRefund', respTranRefund);
            if (!respTranRefund.data?.listTrans || respTranRefund.data?.listTrans?.length <= 0) {
                toast.success('Không có kết quả trả về!')
                return setTranRefund({
                    total: 0,
                    listTrans: [],
                })
            }
            return setTranRefund(respTranRefund.data)
        } catch (error) {
            console.log('error', error);
            toast.error('Có lỗi xảy ra!')
            setTranRefund({
                total: 0,
                listTrans: [],
            })
        }
    }

    const fetchApiGetListPartner = useCallback(async () => {
        try {
            setIsLoading(true)
            const resCustomers = await apiGetListPartner()
            console.log("resCustomers", resCustomers.data.partners)
            if (resCustomers.data.partners != null) {
                resCustomers.data.partners = resCustomers.data.partners.filter((item: any) => !mapCompanyAccounts[item.cpCode])
                setCustomers(resCustomers.data)
            } else {
                setCustomers(initCusgomer)
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        }
    }, [])

    const checkTransactionEvent = async () => {
        setResultOnDataSponsor("")
        const cpCode = customers.partners[Number(selectedCustomer)]?.cpCode ?? '';
        if (!cpCode || !tranId) {
            toast.error('Vui lòng nhập đầy đủ thông tin')
            return
        }
        try {
            setIsLoading(true)
            await fetchTransactions(cpCode, tranId)
            setIsLoading(false)
        } catch (error) {
            toast.error('Vui lòng kiểm tra lại thông tin')
            setIsLoading(false)
        }
    }

    const checkTransactionOnDataSponsor = async (data: any) => {
        try {
            setIsLoading(true)
            setTranId(data.tranId)
            setDataCheck(data)
            const reqTime = dayjs(data.reqTime).format("YYYY-MM-DD")
            await fetchTransactionsOnDataDataSponsor(data.cpCode, data.tranId, reqTime, data.type)
            setIsLoading(false)
        } catch (error) {
            toast.error('Vui lòng kiểm tra lại thông tin')
            setIsLoading(false)
        }
    }

    const checkDataCodeOnDataSponsor = async (data: any) => {
        try {
            setIsLoading(true)
            setDataCheck(data)
            await fetchDataCodeOnDataDataSponsor(data.cpCode, data.dataCodeSerial, data.tranId)
            setIsLoading(false)
        } catch (error) {
            toast.error('Vui lòng kiểm tra lại thông tin')
            setIsLoading(false)
        }
    }

    const checkDataCode = async () => {
        const cpCode = customers.partners[Number(selectedCustomerDataCode)]?.cpCode ?? '';
        if (!cpCode || !dataCodeSerial) {
            toast.error('Vui lòng nhập đầy đủ thông tin')
            return
        }
        try {
            setIsLoading(true)
            await fetchDataCode(cpCode, dataCodeSerial)
            setIsLoading(false)
        } catch (error) {
            toast.error('Vui lòng kiểm tra lại thông tin')
            setIsLoading(false)
        }
    }

    const checkRefund = async () => {
        const cpCode = customers.partners[Number(selectedCustomerDataRefund)]?.cpCode ?? '';
        const time = new Date(timeRefund)
        const year = time?.getFullYear()
        const month = time?.getMonth() + 1
        if (!cpCode || year <= 0 || month <= 0) {
            return toast.error('Vui lòng nhập đầy đủ thông tin')
        }
        try {
            setIsLoading(true)
            await fetchTranRefund(cpCode, year, month)
            setIsLoading(false)
        } catch (error) {
            toast.error('Vui lòng kiểm tra lại thông tin')
            setIsLoading(false)
        }
    }

    const onChangeDate: DatePickerProps['onChange'] = (date, dateString) => {
        setSelectedDate(date as Dayjs);
        console.log(date, dateString);
    };

    const clearEvent = () => {
        setData({} as CheckTransactionResponse);
        setTranId('')
        setSelectedCustomer(0);
        setResultOnDataSponsor("")
    }

    const clearEventCode = () => {
        setDataCode({} as CheckTransactionResponse);
        setDataCodeSerial('')
        setSelectedCustomerCode(0);
    }

    const handleRefundTransaction = async () => {
        try {
            const { tranId, cpCode, day, month, year } = modalSponsor.data
            setIsLoading(true)
            const resp = await apiRefundTransaction({ tranId, cpCode, day, month, year, otpConfirm: cofirmCode })
            if (resp.status === 200) {
                toastSuccess('Hoàn trả giao dịch thành công!')
            }
            setModalSponsor({ data: null, isOpen: false })
            setConfirmCode('')
            setIsLoading(false)
        } catch (error) {
            toastError('Vui lòng kiểm tra lại thông tin!')
            setIsLoading(false)
        }
    }

    const itemsTab: TabsProps['items'] = [
        {
            key: 'data-sponsor',
            label: 'Data sponsor',
            children: (
                <div>
                    <Row gutter={24} style={{ marginBottom: 24 }}>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#e6f7ff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TransactionOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Total Rules</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                                                {data?.total || 0}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#f6ffed',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TransactionOutlined style={{ color: '#52c41a', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Active Rules</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                                                {data?.listTrans?.filter((item: any) => item.return !== 'Refund')?.length || 0}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#fff1f0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TeamOutlined style={{ color: '#f5222d', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Partners</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#f5222d' }}>
                                                {customers.partners?.length}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Card style={{ marginBottom: 24 }}>
                        <Row gutter={16}>
                            <Col span={4}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Chọn đối tác</Text>
                                    <Select
                                        ref={selectRef}
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder="Chọn khách hàng"
                                        optionFilterProp="name"
                                        onChange={(value) => setSelectedCustomer(value)}
                                        filterOption={(input: any, option: any) =>
                                            option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        value={selectedCustomer}
                                    >
                                        {customers?.partners?.map((customer: any, idx: React.Key) => (
                                            <Select.Option key={idx} value={idx}>
                                                {customer.name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>
                            </Col>
                            <Col span={4}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Transaction Id</Text>
                                    <Input
                                        placeholder="Nhập mã giao dịch"
                                        value={tranId}
                                        onChange={(event) => setTranId(event.target.value)}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </Col>
                            <Col span={4}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Chọn thời gian</Text>
                                    <DatePicker
                                        allowClear={false}
                                        onChange={onChangeDate}
                                        value={selectedDate}
                                        picker="date"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8, opacity: 0 }}>Actions</Text>
                                    <Space style={{ width: '100%' }}>
                                        <Button type="primary" onClick={checkTransactionEvent} style={{ flex: 1 }}>
                                            Tìm kiếm
                                        </Button>
                                        <Button danger onClick={clearEvent} style={{ flex: 1 }} icon={<ReloadOutlined />}>
                                        </Button>
                                    </Space>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                    <Row gutter={16}>
                        {data?.listTrans && data?.listTrans?.length > 0 ? (
                            data?.listTrans?.map((transaction: any, index: number) => (
                                <Col span={24} key={transaction.id} style={{ marginBottom: 16 }}>
                                    <Card
                                        style={{
                                            borderRadius: 8,
                                            border: '1px solid #f0f0f0'
                                        }}
                                    >
                                        <div style={{ marginBottom: 12 }}>
                                            <Row justify="space-between" align="middle">
                                                <Col span={24}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                                            <div style={{
                                                                width: 32,
                                                                height: 32,
                                                                borderRadius: '50%',
                                                                backgroundColor: transaction.return === 'Refund' ? '#ff4d4f' : '#52c41a',
                                                                color: 'white',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontWeight: 'bold',
                                                                fontSize: '12px'
                                                            }}>
                                                                {index + 1}
                                                            </div>
                                                            <div>
                                                                <Title level={5} style={{ margin: 0, marginBottom: 4 }}>
                                                                    {transaction.id}
                                                                </Title>
                                                                <Text type="secondary">
                                                                    {transaction.cpCode}
                                                                </Text>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <Text style={{ fontSize: '14px', fontWeight: 500, whiteSpace: 'nowrap' }}>
                                                                <b>TranId: </b> {transaction.tranId}
                                                            </Text>
                                                            <div style={{ textAlign: 'right', marginTop: 10 }}>
                                                                <Tag color={transaction.return === "SUCCESS" ? "success" : "error"}>
                                                                    {transaction.return}
                                                                </Tag>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>

                                        <Row gutter={16} style={{ marginBottom: 12 }}>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>PLATFORM</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {transaction.platform}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>MSISDN</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {transaction.msisdn}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>PRICE</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {transaction.type === 'REGISTER_COMBO_PROMOTION' ? 0 : formatCurrency(transaction.price)}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>PACKAGE NAME</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {transaction.packageName}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>DATA PACK</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {transaction.dataPack}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>TYPE</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {transaction.type}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            marginTop: 12,
                                            padding: '12px',
                                            backgroundColor: '#fafafa',
                                            borderRadius: 6,
                                            border: '1px solid #f0f0f0'
                                        }}>
                                            <div>
                                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>REQ TIME</Text>
                                                <div style={{ marginTop: 4 }}>
                                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                        {dayjs(transaction.reqTime).format("YYYY-MM-DD HH:mm:ss")}
                                                    </Text>
                                                </div>
                                            </div>
                                            <Space>
                                                <Button
                                                    key="refund"
                                                    disabled={transaction.return === 'Refund' || transaction.type === 'REGISTER_COMBO_PROMOTION'}
                                                    onClick={() => setModalSponsor({ data: transaction, isOpen: true })}
                                                    type="primary"
                                                    size="small"
                                                >
                                                    Refund
                                                </Button>
                                                <Button
                                                    key="check"
                                                    onClick={() => checkTransactionOnDataSponsor(transaction)}
                                                    size="small"
                                                >
                                                    Kiểm tra
                                                </Button>
                                            </Space>
                                        </div>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col span={24}>
                                <Card style={{ textAlign: 'center', padding: '40px 20px' }}>
                                    <div style={{ color: '#8c8c8c', fontSize: '16px', marginBottom: 16 }}>
                                        <TransactionOutlined style={{ fontSize: '48px', marginBottom: 16, display: 'block' }} />
                                        <Title level={4} style={{ color: '#8c8c8c' }}>No Transactions Found</Title>
                                        <Text type="secondary">
                                            No transaction data available. Please search with different criteria.
                                        </Text>
                                    </div>
                                </Card>
                            </Col>
                        )}
                    </Row>
                    {resultOnDataSponsor?.length > 0 && (
                        <>
                            <div style={{ width: "100%", marginBottom: 24 }}>
                                <Card>
                                    <div style={{ marginBottom: 24 }}>
                                        <Title level={5}>Kết quả kiểm tra của giao dịch {tranId}</Title>
                                    </div>
                                    <Tabs type='card' defaultActiveKey="overview" items={[
                                        {
                                            key: 'overview',
                                            label: 'Overview',
                                            children: (
                                                <div>
                                                    <Row gutter={[24, 24]}>
                                                        <Col span={12}>
                                                            <Card>
                                                                <Title level={5} style={{ marginBottom: 16 }}>Transaction Summary</Title>
                                                                <Row>
                                                                    <Col span={12}>
                                                                        <Text type="secondary">Status</Text>
                                                                        <div>
                                                                            <Tag color={dataCheck.return === "SUCCESS" ? "green" : "red"}>
                                                                                {dataCheck.return}
                                                                            </Tag>
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={12}>
                                                                        <Text type="secondary">DetailCode</Text>
                                                                        <div>
                                                                            <Text strong>{dataCheck.detailCode}</Text>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Divider />
                                                                <Row>
                                                                    <Col span={24}>
                                                                        <Text type="secondary">Description</Text>
                                                                        <div>
                                                                            <Text>{dataCheck.description}</Text>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Card>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Card>
                                                                <Title level={5} style={{ marginBottom: 16 }}>Fee Breakdown</Title>
                                                                <Row>
                                                                    <Col span={12}>
                                                                        <Text type="secondary">Price</Text>
                                                                        <div>
                                                                            <Text strong>{formatCurrency(dataCheck.price)}</Text>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Divider />
                                                                <Row>
                                                                    <Col span={12}>
                                                                        <Text type="secondary">Network</Text>
                                                                        <div>
                                                                            <Text>{dataCheck.network}</Text>
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={12}>
                                                                        <Text type="secondary">Type</Text>
                                                                        <div>
                                                                            <Text>{dataCheck.type}</Text>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginTop: 20 }} gutter={[24, 24]}>
                                                        <Col span={12}>
                                                            <Card>
                                                                <Title level={5} style={{ marginBottom: 16 }}>Customer Information</Title>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Msisdn</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.msisdn}</Text>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Platform</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.platform}</Text>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Data Pack</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.dataPack}</Text>
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Card>
                                                                <Title level={5} style={{ marginBottom: 16 }}>Timeline</Title>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">CreatedAt</Text>
                                                                    <div>
                                                                        <Text strong>{dayjs(dataCheck.createdAt).format('DD/MM/YYYY HH:mm:ss')}</Text>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">UpdatedAt</Text>
                                                                    <div>
                                                                        <Text strong>{dayjs(dataCheck.updatedAt).format('DD/MM/YYYY HH:mm:ss')}</Text>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Req Time</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.reqTime}</Text>
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ),
                                        },
                                        {
                                            key: 'request/response-flow',
                                            label: 'Request/Response Flow',
                                            children: (
                                                <div style={{ width: "100%" }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
                                                        <Title level={5}>Request/Response Flow</Title>
                                                        <Tag>{auditLogs?.length * 2} Log Entries</Tag>
                                                    </div>
                                                    {auditLogs?.length > 0 && auditLogs.map((log: any, index: number) => (
                                                        <div key={index} style={{ padding: 12, background: '#f9f9f9', borderRadius: 8, marginBottom: 32 }}>
                                                            <div style={{ marginBottom: 10 }}>
                                                                <b>Response Time</b>: {log.response_time ? `${log.response_time} ms` : 'N/A'}
                                                            </div>
                                                            <Card size='small' style={{ marginBottom: 24, borderRadius: 8 }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                                                    <ArrowRightOutlined style={{ color: '#1890ff', marginRight: 8 }} />
                                                                    <Text strong>Partner → System</Text>
                                                                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                                                                        <Text type="secondary" style={{ marginRight: 8 }}>
                                                                            {log.created_at ? dayjs(log.created_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                        </Text>
                                                                        {log.response ? (
                                                                            <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                                {log.status || 'UNKNOWN'}
                                                                            </Tag>
                                                                        ) : (
                                                                            <Tag color='warning'>UNKNOWN</Tag>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <Collapse
                                                                    defaultActiveKey={['response']}
                                                                    items={[
                                                                        {
                                                                            key: 'request',
                                                                            label: 'Request',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                                    <JsonView src={log.request} />
                                                                                </div>
                                                                            ),
                                                                        },
                                                                        {
                                                                            key: 'response',
                                                                            label: 'Response',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                                    <JsonView src={log.response} />
                                                                                </div>
                                                                            ),
                                                                        },
                                                                    ]}
                                                                />
                                                            </Card>

                                                            <Card size='small' style={{ marginBottom: 24, borderRadius: 8 }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                                                    <ArrowRightOutlined style={{ color: '#1890ff', marginRight: 8 }} />
                                                                    <Text strong>System → Provider</Text>
                                                                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                                                                        <Text type="secondary" style={{ marginRight: 8 }}>
                                                                            {log.updated_at ? dayjs(log.updated_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                        </Text>
                                                                        {log.response_adapter ? (
                                                                            <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                                {log.status || 'UNKNOWN'}
                                                                            </Tag>
                                                                        ) : (
                                                                            <Tag color='warning'>UNKNOWN</Tag>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <Collapse
                                                                    defaultActiveKey={['response', 'error']}
                                                                    items={[
                                                                        {
                                                                            key: 'request',
                                                                            label: 'Request',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                                    <JsonView src={log.request_adapter} />
                                                                                </div>
                                                                            ),
                                                                        },
                                                                        log.response_adapter ? {
                                                                            key: 'response',
                                                                            label: 'Response',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                                    <JsonView src={log.response_adapter} />
                                                                                </div>
                                                                            ),
                                                                        } : {
                                                                            key: 'error',
                                                                            label: 'Error',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4, overflowWrap: 'break-word' }}>
                                                                                    {log.error}
                                                                                </div>
                                                                            ),
                                                                        },
                                                                    ]}
                                                                />
                                                            </Card>
                                                        </div>
                                                    ))}
                                                </div>
                                            ),
                                        },
                                        {
                                            key: 'timeline',
                                            label: 'Timeline',
                                            children: (
                                                <div style={{ width: "100%" }}>
                                                    <div style={{ marginBottom: 32 }}>
                                                        <Title level={5}>Transaction Timeline</Title>
                                                        <Text type="secondary">Complete timeline of transaction events and state changes</Text>
                                                    </div>
                                                    {auditLogs?.length > 0 && auditLogs.map((log: any, index: number) => (
                                                        <div key={index} style={{ marginBottom: 32 }}>
                                                            <div style={{ marginBottom: 16 }}>
                                                                <b>Response Time</b>: {log.response_time ? `${log.response_time} ms` : 'N/A'}
                                                            </div>
                                                            <Timeline
                                                                items={[
                                                                    {
                                                                        dot: <ClockCircleOutlined style={{ fontSize: '16px' }} />,
                                                                        children: (
                                                                            <>
                                                                                <Text strong>Transaction Created</Text>
                                                                                <div>
                                                                                    <Text type="secondary">
                                                                                        {log.created_at ? dayjs(log.created_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                                    </Text>
                                                                                </div>
                                                                                <div>
                                                                                    <Text>IP Address: {log.ip_address}</Text>
                                                                                </div>
                                                                            </>
                                                                        ),
                                                                    },
                                                                    {
                                                                        dot: <CheckCircleOutlined style={{ fontSize: '16px', color: '#52c41a' }} />,
                                                                        children: (
                                                                            <>
                                                                                <Text strong>Partner → System</Text>
                                                                                <div>
                                                                                    <Text type="secondary">
                                                                                        {log.created_at ? dayjs(log.created_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                                    </Text>
                                                                                </div>
                                                                                <div>
                                                                                    <Text>
                                                                                        Status: {log.response ? (
                                                                                            <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                                                {log.status || 'UNKNOWN'}
                                                                                            </Tag>
                                                                                        ) : (
                                                                                            <Tag color='warning'>UNKNOWN</Tag>
                                                                                        )}
                                                                                    </Text>
                                                                                </div>
                                                                            </>
                                                                        ),
                                                                    },
                                                                    {
                                                                        dot: <CheckCircleOutlined style={{ fontSize: '16px', color: '#52c41a' }} />,
                                                                        children: (
                                                                            <>
                                                                                <Text strong>System → Provider</Text>
                                                                                <div>
                                                                                    <Text type="secondary">
                                                                                        {log.updated_at ? dayjs(log.updated_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                                    </Text>
                                                                                </div>
                                                                                <div>
                                                                                    <Text>
                                                                                        Status: {log.response_adapter ? (
                                                                                            <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                                                {log.status || 'UNKNOWN'}
                                                                                            </Tag>
                                                                                        ) : (
                                                                                            <Tag color='warning'>UNKNOWN</Tag>
                                                                                        )}
                                                                                    </Text>
                                                                                </div>
                                                                            </>
                                                                        ),
                                                                    },
                                                                ]}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            ),
                                        },
                                        {
                                            key: 'result',
                                            label: 'Result',
                                            children: (
                                                <div style={{ width: "100%" }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
                                                        <div>
                                                            <Title level={5}>Result Transaction Data</Title>
                                                            <Text type="secondary">Complete transaction object in JSON format</Text>
                                                        </div>
                                                    </div>

                                                    <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                        <JsonView src={JSON.parse(resultOnDataSponsor)} />
                                                    </div>
                                                </div>
                                            ),
                                        }
                                    ]} />
                                </Card>
                            </div>
                        </>
                    )}
                </div>
            ),
        },
        {
            key: 'data-code',
            label: 'Data code',
            children: (
                <div>
                    <Row gutter={24} style={{ marginBottom: 24 }}>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#e6f7ff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <GiftOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Total Rules</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                                                {dataCode?.total || 0}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#f6ffed',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <GiftOutlined style={{ color: '#52c41a', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Active Rules</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                                                {dataCode?.dataCodeModels?.filter((item: any) => item.dataCode)?.length || 0}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#fff1f0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TeamOutlined style={{ color: '#f5222d', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Partners</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#f5222d' }}>
                                                {customers.partners?.length}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Card style={{ marginBottom: 24 }}>
                        <Row gutter={16}>
                            <Col span={4}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Chọn đối tác</Text>
                                    <Select
                                        ref={selectCodeRef}
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder="Chọn khách hàng"
                                        optionFilterProp="name"
                                        onChange={(value) => setSelectedCustomerCode(value)}
                                        filterOption={(input: any, option: any) =>
                                            option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        value={selectedCustomerDataCode}
                                    >
                                        {customers?.partners?.map((customer: any, idx: React.Key) => (
                                            <Select.Option key={idx} value={idx}>
                                                {customer.name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>
                            </Col>
                            <Col span={4}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Data Code Serial</Text>
                                    <Input
                                        placeholder="Nhập Data Code Serial"
                                        value={dataCodeSerial}
                                        onChange={(event) => setDataCodeSerial(event.target.value)}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </Col>
                            <Col span={4}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Chọn thời gian</Text>
                                    <DatePicker
                                        allowClear={false}
                                        onChange={onChangeDate}
                                        value={selectedDate}
                                        picker="date"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8, opacity: 0 }}>Actions</Text>
                                    <Space style={{ width: '100%' }}>
                                        <Button type="primary" onClick={checkDataCode} style={{ flex: 1 }}>
                                            Tìm kiếm
                                        </Button>
                                        <Button danger onClick={clearEventCode} style={{ flex: 1 }} icon={<ReloadOutlined />}>
                                        </Button>
                                    </Space>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                    <Row gutter={16}>
                        {dataCode?.dataCodeModels && dataCode?.dataCodeModels?.length > 0 ? (
                            dataCode?.dataCodeModels?.map((code: any, index: number) => (
                                <Col span={24} key={code.id} style={{ marginBottom: 16 }}>
                                    <Card
                                        style={{
                                            borderRadius: 8,
                                            border: '1px solid #f0f0f0'
                                        }}
                                    >
                                        <div style={{ marginBottom: 12 }}>
                                            <Row justify="space-between" align="middle">
                                                <Col span={24}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                                            <div style={{
                                                                width: 32,
                                                                height: 32,
                                                                borderRadius: '50%',
                                                                backgroundColor: '#1890ff',
                                                                color: 'white',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontWeight: 'bold',
                                                                fontSize: '12px'
                                                            }}>
                                                                {index + 1}
                                                            </div>
                                                            <div>
                                                                <Title level={5} style={{ margin: 0, marginBottom: 4 }}>
                                                                    {code.id}
                                                                </Title>
                                                                <Text type="secondary">
                                                                    {code.cpCode}
                                                                </Text>
                                                            </div>
                                                        </div>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500, whiteSpace: 'nowrap' }}>
                                                            <b>Data Code: </b> {code.dataCode}
                                                        </Text>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>

                                        <Row gutter={16} style={{ marginBottom: 12 }}>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>TRAN ID</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {code.tranId}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>SERIAL</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {code.dataCodeSerial}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>PACKAGE CODE</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {code.packageCode}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>START DATE</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {code.startDate}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>END DATE</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {code.endDate}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            marginTop: 12,
                                            padding: '12px',
                                            backgroundColor: '#fafafa',
                                            borderRadius: 6,
                                            border: '1px solid #f0f0f0'
                                        }}>
                                            <div>
                                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>CREATED AT</Text>
                                                <div style={{ marginTop: 4 }}>
                                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                        {code.createdAt}
                                                    </Text>
                                                </div>
                                            </div>
                                            <Button
                                                key="check"
                                                onClick={() => checkDataCodeOnDataSponsor(code)}
                                                type="primary"
                                                size="small"
                                            >
                                                Kiểm tra
                                            </Button>
                                        </div>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col span={24}>
                                <Card style={{ textAlign: 'center', padding: '40px 20px' }}>
                                    <div style={{ color: '#8c8c8c', fontSize: '16px', marginBottom: 16 }}>
                                        <GiftOutlined style={{ fontSize: '48px', marginBottom: 16, display: 'block' }} />
                                        <Title level={4} style={{ color: '#8c8c8c' }}>No Data Codes Found</Title>
                                        <Text type="secondary">
                                            No data code records available. Please search with different criteria.
                                        </Text>
                                    </div>
                                </Card>
                            </Col>
                        )}
                    </Row>
                    {resultOnDataSponsor?.length > 0 && (
                        <>
                            <div style={{ width: "100%", marginBottom: 24 }}>
                                <Card>
                                    <div style={{ marginBottom: 24 }}>
                                        <Title level={5}>Kết quả kiểm tra của giao dịch {dataCodeSerial}</Title>
                                    </div>
                                    <Tabs type='card' defaultActiveKey="overview" items={[
                                        {
                                            key: 'overview',
                                            label: 'Overview',
                                            children: (
                                                <div>
                                                    <Row gutter={[24, 24]}>
                                                        <Col span={12}>
                                                            <Card>
                                                                <Title level={5} style={{ marginBottom: 16 }}>Transaction Summary</Title>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Tran Id</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.tranId}</Text>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Transaction Id</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.transactionId}</Text>
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Card>
                                                                <Title level={5} style={{ marginBottom: 16 }}>Fee Breakdown</Title>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Package Code</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.packageCode}</Text>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Value</Text>
                                                                    <div>
                                                                        <Text strong>{formatCurrency(dataCheck.value)}</Text>
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginTop: 20 }} gutter={[24, 24]}>
                                                        <Col span={12}>
                                                            <Card>
                                                                <Title level={5} style={{ marginBottom: 16 }}>Customer Information</Title>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Data Code Id</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.dataCode}</Text>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Data Code</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.dataCode}</Text>
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Card>
                                                                <Title level={5} style={{ marginBottom: 16 }}>Timeline</Title>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">CreatedAt</Text>
                                                                    <div>
                                                                        <Text strong>{dayjs(dataCheck.createdAt).format('DD/MM/YYYY HH:mm:ss')}</Text>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">UpdatedAt</Text>
                                                                    <div>
                                                                        <Text strong>{dayjs(dataCheck.updatedAt).format('DD/MM/YYYY HH:mm:ss')}</Text>
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ),
                                        },
                                        {
                                            key: 'request/response-flow',
                                            label: 'Request/Response Flow',
                                            children: (
                                                <div style={{ width: "100%" }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
                                                        <Title level={5}>Request/Response Flow</Title>
                                                        <Tag>{auditLogs?.length * 2} Log Entries</Tag>
                                                    </div>
                                                    {auditLogs?.length > 0 && auditLogs.map((log: any, index: number) => (
                                                        <div key={index} style={{ padding: 12, background: '#f9f9f9', borderRadius: 8, marginBottom: 32 }}>
                                                            <div style={{ marginBottom: 10 }}>
                                                                <b>Response Time</b>: {log.response_time ? `${log.response_time} ms` : 'N/A'}
                                                            </div>
                                                            <Card size='small' style={{ marginBottom: 24, borderRadius: 8 }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                                                    <ArrowRightOutlined style={{ color: '#1890ff', marginRight: 8 }} />
                                                                    <Text strong>Partner → System</Text>
                                                                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                                                                        <Text type="secondary" style={{ marginRight: 8 }}>
                                                                            {log.created_at ? dayjs(log.created_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                        </Text>
                                                                        {log.response ? (
                                                                            <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                                {log.status || 'UNKNOWN'}
                                                                            </Tag>
                                                                        ) : (
                                                                            <Tag color='warning'>UNKNOWN</Tag>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <Collapse
                                                                    defaultActiveKey={['response']}
                                                                    items={[
                                                                        {
                                                                            key: 'request',
                                                                            label: 'Request',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                                    <JsonView src={log.request} />
                                                                                </div>
                                                                            ),
                                                                        },
                                                                        {
                                                                            key: 'response',
                                                                            label: 'Response',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                                    <JsonView src={log.response} />
                                                                                </div>
                                                                            ),
                                                                        },
                                                                    ]}
                                                                />
                                                            </Card>

                                                            <Card size='small' style={{ marginBottom: 24, borderRadius: 8 }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                                                    <ArrowRightOutlined style={{ color: '#1890ff', marginRight: 8 }} />
                                                                    <Text strong>System → Provider</Text>
                                                                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                                                                        <Text type="secondary" style={{ marginRight: 8 }}>
                                                                            {log.updated_at ? dayjs(log.updated_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                        </Text>
                                                                        {log.response_adapter ? (
                                                                            <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                                {log.status || 'UNKNOWN'}
                                                                            </Tag>
                                                                        ) : (
                                                                            <Tag color='warning'>UNKNOWN</Tag>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <Collapse
                                                                    defaultActiveKey={['response', 'error']}
                                                                    items={[
                                                                        {
                                                                            key: 'request',
                                                                            label: 'Request',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                                    <JsonView src={log.request_adapter} />
                                                                                </div>
                                                                            ),
                                                                        },
                                                                        log.response_adapter ? {
                                                                            key: 'response',
                                                                            label: 'Response',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                                    <JsonView src={log.response_adapter} />
                                                                                </div>
                                                                            ),
                                                                        } : {
                                                                            key: 'error',
                                                                            label: 'Error',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4, overflowWrap: 'break-word' }}>
                                                                                    {log.error}
                                                                                </div>
                                                                            ),
                                                                        },
                                                                    ]}
                                                                />
                                                            </Card>
                                                        </div>
                                                    ))}
                                                </div>
                                            ),
                                        },
                                        {
                                            key: 'timeline',
                                            label: 'Timeline',
                                            children: (
                                                <div style={{ width: "100%" }}>
                                                    <div style={{ marginBottom: 32 }}>
                                                        <Title level={5}>Transaction Timeline</Title>
                                                        <Text type="secondary">Complete timeline of transaction events and state changes</Text>
                                                    </div>
                                                    {auditLogs?.length > 0 && auditLogs.map((log: any, index: number) => (
                                                        <div key={index} style={{ marginBottom: 32 }}>
                                                            <div style={{ marginBottom: 16 }}>
                                                                <b>Response Time</b>: {log.response_time ? `${log.response_time} ms` : 'N/A'}
                                                            </div>
                                                            <Timeline
                                                                items={[
                                                                    {
                                                                        dot: <ClockCircleOutlined style={{ fontSize: '16px' }} />,
                                                                        children: (
                                                                            <>
                                                                                <Text strong>Transaction Created</Text>
                                                                                <div>
                                                                                    <Text type="secondary">
                                                                                        {log.created_at ? dayjs(log.created_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                                    </Text>
                                                                                </div>
                                                                                <div>
                                                                                    <Text>IP Address: {log.ip_address}</Text>
                                                                                </div>
                                                                            </>
                                                                        ),
                                                                    },
                                                                    {
                                                                        dot: <CheckCircleOutlined style={{ fontSize: '16px', color: '#52c41a' }} />,
                                                                        children: (
                                                                            <>
                                                                                <Text strong>Partner → System</Text>
                                                                                <div>
                                                                                    <Text type="secondary">
                                                                                        {log.created_at ? dayjs(log.created_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                                    </Text>
                                                                                </div>
                                                                                <div>
                                                                                    <Text>
                                                                                        Status: {log.response ? (
                                                                                            <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                                                {log.status || 'UNKNOWN'}
                                                                                            </Tag>
                                                                                        ) : (
                                                                                            <Tag color='warning'>UNKNOWN</Tag>
                                                                                        )}
                                                                                    </Text>
                                                                                </div>
                                                                            </>
                                                                        ),
                                                                    },
                                                                    {
                                                                        dot: <CheckCircleOutlined style={{ fontSize: '16px', color: '#52c41a' }} />,
                                                                        children: (
                                                                            <>
                                                                                <Text strong>System → Provider</Text>
                                                                                <div>
                                                                                    <Text type="secondary">
                                                                                        {log.updated_at ? dayjs(log.updated_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                                    </Text>
                                                                                </div>
                                                                                <div>
                                                                                    <Text>
                                                                                        Status: {log.response_adapter ? (
                                                                                            <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                                                {log.status || 'UNKNOWN'}
                                                                                            </Tag>
                                                                                        ) : (
                                                                                            <Tag color='warning'>UNKNOWN</Tag>
                                                                                        )}
                                                                                    </Text>
                                                                                </div>
                                                                            </>
                                                                        ),
                                                                    },
                                                                ]}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            ),
                                        },
                                        {
                                            key: 'result',
                                            label: 'Result',
                                            children: (
                                                <div style={{ width: "100%" }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
                                                        <div>
                                                            <Title level={5}>Result Transaction Data</Title>
                                                            <Text type="secondary">Complete transaction object in JSON format</Text>
                                                        </div>
                                                    </div>

                                                    <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                        <JsonView src={JSON.parse(resultOnDataSponsor)} />
                                                    </div>
                                                </div>
                                            ),
                                        }
                                    ]} />
                                </Card>
                            </div>
                        </>
                    )}
                </div>
            ),
        },
        {
            key: 'top-up',
            label: 'Top up',
            children: (
                <div>
                    <Row gutter={24} style={{ marginBottom: 24 }}>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#e6f7ff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <GiftOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Total Rules</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                                                {dataCode?.total || 0}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#f6ffed',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <GiftOutlined style={{ color: '#52c41a', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Active Rules</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                                                {dataCode?.dataCodeModels?.filter((item: any) => item.dataCode)?.length || 0}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#fff1f0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TeamOutlined style={{ color: '#f5222d', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Partners</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#f5222d' }}>
                                                {customers.partners?.length}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Card style={{ marginBottom: 24 }}>
                        <Row gutter={16}>
                            <Col span={4}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Chọn đối tác</Text>
                                    <Select
                                        ref={selectCodeRef}
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder="Chọn khách hàng"
                                        optionFilterProp="name"
                                        onChange={(value) => setSelectedCustomerCode(value)}
                                        filterOption={(input: any, option: any) =>
                                            option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        value={selectedCustomerDataCode}
                                    >
                                        {customers?.partners?.map((customer: any, idx: React.Key) => (
                                            <Select.Option key={idx} value={idx}>
                                                {customer.name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>
                            </Col>
                            <Col span={4}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Data Code Serial</Text>
                                    <Input
                                        placeholder="Nhập Data Code Serial"
                                        value={dataCodeSerial}
                                        onChange={(event) => setDataCodeSerial(event.target.value)}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </Col>
                            <Col span={4}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Chọn thời gian</Text>
                                    <DatePicker
                                        allowClear={false}
                                        onChange={onChangeDate}
                                        value={selectedDate}
                                        picker="date"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8, opacity: 0 }}>Actions</Text>
                                    <Space style={{ width: '100%' }}>
                                        <Button type="primary" onClick={checkDataCode} style={{ flex: 1 }}>
                                            Tìm kiếm
                                        </Button>
                                        <Button danger onClick={clearEventCode} style={{ flex: 1 }} icon={<ReloadOutlined />}>
                                        </Button>
                                    </Space>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                    <Row gutter={16}>
                        {dataCode?.dataCodeModels && dataCode?.dataCodeModels?.length > 0 ? (
                            dataCode?.dataCodeModels?.map((code: any, index: number) => (
                                <Col span={24} key={code.id} style={{ marginBottom: 16 }}>
                                    <Card
                                        style={{
                                            borderRadius: 8,
                                            border: '1px solid #f0f0f0'
                                        }}
                                    >
                                        <div style={{ marginBottom: 12 }}>
                                            <Row justify="space-between" align="middle">
                                                <Col span={24}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                                            <div style={{
                                                                width: 32,
                                                                height: 32,
                                                                borderRadius: '50%',
                                                                backgroundColor: '#1890ff',
                                                                color: 'white',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontWeight: 'bold',
                                                                fontSize: '12px'
                                                            }}>
                                                                {index + 1}
                                                            </div>
                                                            <div>
                                                                <Title level={5} style={{ margin: 0, marginBottom: 4 }}>
                                                                    {code.id}
                                                                </Title>
                                                                <Text type="secondary">
                                                                    {code.cpCode}
                                                                </Text>
                                                            </div>
                                                        </div>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500, whiteSpace: 'nowrap' }}>
                                                            <b>Data Code: </b> {code.dataCode}
                                                        </Text>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>

                                        <Row gutter={16} style={{ marginBottom: 12 }}>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>TRAN ID</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {code.tranId}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>SERIAL</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {code.dataCodeSerial}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>PACKAGE CODE</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {code.packageCode}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>START DATE</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {code.startDate}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>END DATE</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {code.endDate}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            marginTop: 12,
                                            padding: '12px',
                                            backgroundColor: '#fafafa',
                                            borderRadius: 6,
                                            border: '1px solid #f0f0f0'
                                        }}>
                                            <div>
                                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>CREATED AT</Text>
                                                <div style={{ marginTop: 4 }}>
                                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                        {code.createdAt}
                                                    </Text>
                                                </div>
                                            </div>
                                            <Button
                                                key="check"
                                                onClick={() => checkDataCodeOnDataSponsor(code)}
                                                type="primary"
                                                size="small"
                                            >
                                                Kiểm tra
                                            </Button>
                                        </div>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col span={24}>
                                <Card style={{ textAlign: 'center', padding: '40px 20px' }}>
                                    <div style={{ color: '#8c8c8c', fontSize: '16px', marginBottom: 16 }}>
                                        <GiftOutlined style={{ fontSize: '48px', marginBottom: 16, display: 'block' }} />
                                        <Title level={4} style={{ color: '#8c8c8c' }}>No Data Codes Found</Title>
                                        <Text type="secondary">
                                            No data code records available. Please search with different criteria.
                                        </Text>
                                    </div>
                                </Card>
                            </Col>
                        )}
                    </Row>
                    {resultOnDataSponsor?.length > 0 && (
                        <>
                            <div style={{ width: "100%", marginBottom: 24 }}>
                                <Card>
                                    <div style={{ marginBottom: 24 }}>
                                        <Title level={5}>Kết quả kiểm tra của giao dịch {dataCodeSerial}</Title>
                                    </div>
                                    <Tabs type='card' defaultActiveKey="overview" items={[
                                        {
                                            key: 'overview',
                                            label: 'Overview',
                                            children: (
                                                <div>
                                                    <Row gutter={[24, 24]}>
                                                        <Col span={12}>
                                                            <Card>
                                                                <Title level={5} style={{ marginBottom: 16 }}>Transaction Summary</Title>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Tran Id</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.tranId}</Text>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Transaction Id</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.transactionId}</Text>
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Card>
                                                                <Title level={5} style={{ marginBottom: 16 }}>Fee Breakdown</Title>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Package Code</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.packageCode}</Text>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Value</Text>
                                                                    <div>
                                                                        <Text strong>{formatCurrency(dataCheck.value)}</Text>
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginTop: 20 }} gutter={[24, 24]}>
                                                        <Col span={12}>
                                                            <Card>
                                                                <Title level={5} style={{ marginBottom: 16 }}>Customer Information</Title>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Data Code Id</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.dataCode}</Text>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">Data Code</Text>
                                                                    <div>
                                                                        <Text strong>{dataCheck.dataCode}</Text>
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Card>
                                                                <Title level={5} style={{ marginBottom: 16 }}>Timeline</Title>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">CreatedAt</Text>
                                                                    <div>
                                                                        <Text strong>{dayjs(dataCheck.createdAt).format('DD/MM/YYYY HH:mm:ss')}</Text>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                                    <Text type="secondary">UpdatedAt</Text>
                                                                    <div>
                                                                        <Text strong>{dayjs(dataCheck.updatedAt).format('DD/MM/YYYY HH:mm:ss')}</Text>
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ),
                                        },
                                        {
                                            key: 'request/response-flow',
                                            label: 'Request/Response Flow',
                                            children: (
                                                <div style={{ width: "100%" }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
                                                        <Title level={5}>Request/Response Flow</Title>
                                                        <Tag>{auditLogs?.length * 2} Log Entries</Tag>
                                                    </div>
                                                    {auditLogs?.length > 0 && auditLogs.map((log: any, index: number) => (
                                                        <div key={index} style={{ padding: 12, background: '#f9f9f9', borderRadius: 8, marginBottom: 32 }}>
                                                            <div style={{ marginBottom: 10 }}>
                                                                <b>Response Time</b>: {log.response_time ? `${log.response_time} ms` : 'N/A'}
                                                            </div>
                                                            <Card size='small' style={{ marginBottom: 24, borderRadius: 8 }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                                                    <ArrowRightOutlined style={{ color: '#1890ff', marginRight: 8 }} />
                                                                    <Text strong>Partner → System</Text>
                                                                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                                                                        <Text type="secondary" style={{ marginRight: 8 }}>
                                                                            {log.created_at ? dayjs(log.created_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                        </Text>
                                                                        {log.response ? (
                                                                            <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                                {log.status || 'UNKNOWN'}
                                                                            </Tag>
                                                                        ) : (
                                                                            <Tag color='warning'>UNKNOWN</Tag>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <Collapse
                                                                    defaultActiveKey={['response']}
                                                                    items={[
                                                                        {
                                                                            key: 'request',
                                                                            label: 'Request',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                                    <JsonView src={log.request} />
                                                                                </div>
                                                                            ),
                                                                        },
                                                                        {
                                                                            key: 'response',
                                                                            label: 'Response',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                                    <JsonView src={log.response} />
                                                                                </div>
                                                                            ),
                                                                        },
                                                                    ]}
                                                                />
                                                            </Card>

                                                            <Card size='small' style={{ marginBottom: 24, borderRadius: 8 }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                                                    <ArrowRightOutlined style={{ color: '#1890ff', marginRight: 8 }} />
                                                                    <Text strong>System → Provider</Text>
                                                                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                                                                        <Text type="secondary" style={{ marginRight: 8 }}>
                                                                            {log.updated_at ? dayjs(log.updated_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                        </Text>
                                                                        {log.response_adapter ? (
                                                                            <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                                {log.status || 'UNKNOWN'}
                                                                            </Tag>
                                                                        ) : (
                                                                            <Tag color='warning'>UNKNOWN</Tag>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <Collapse
                                                                    defaultActiveKey={['response', 'error']}
                                                                    items={[
                                                                        {
                                                                            key: 'request',
                                                                            label: 'Request',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                                    <JsonView src={log.request_adapter} />
                                                                                </div>
                                                                            ),
                                                                        },
                                                                        log.response_adapter ? {
                                                                            key: 'response',
                                                                            label: 'Response',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                                    <JsonView src={log.response_adapter} />
                                                                                </div>
                                                                            ),
                                                                        } : {
                                                                            key: 'error',
                                                                            label: 'Error',
                                                                            children: (
                                                                                <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4, overflowWrap: 'break-word' }}>
                                                                                    {log.error}
                                                                                </div>
                                                                            ),
                                                                        },
                                                                    ]}
                                                                />
                                                            </Card>
                                                        </div>
                                                    ))}
                                                </div>
                                            ),
                                        },
                                        {
                                            key: 'timeline',
                                            label: 'Timeline',
                                            children: (
                                                <div style={{ width: "100%" }}>
                                                    <div style={{ marginBottom: 32 }}>
                                                        <Title level={5}>Transaction Timeline</Title>
                                                        <Text type="secondary">Complete timeline of transaction events and state changes</Text>
                                                    </div>
                                                    {auditLogs?.length > 0 && auditLogs.map((log: any, index: number) => (
                                                        <div key={index} style={{ marginBottom: 32 }}>
                                                            <div style={{ marginBottom: 16 }}>
                                                                <b>Response Time</b>: {log.response_time ? `${log.response_time} ms` : 'N/A'}
                                                            </div>
                                                            <Timeline
                                                                items={[
                                                                    {
                                                                        dot: <ClockCircleOutlined style={{ fontSize: '16px' }} />,
                                                                        children: (
                                                                            <>
                                                                                <Text strong>Transaction Created</Text>
                                                                                <div>
                                                                                    <Text type="secondary">
                                                                                        {log.created_at ? dayjs(log.created_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                                    </Text>
                                                                                </div>
                                                                                <div>
                                                                                    <Text>IP Address: {log.ip_address}</Text>
                                                                                </div>
                                                                            </>
                                                                        ),
                                                                    },
                                                                    {
                                                                        dot: <CheckCircleOutlined style={{ fontSize: '16px', color: '#52c41a' }} />,
                                                                        children: (
                                                                            <>
                                                                                <Text strong>Partner → System</Text>
                                                                                <div>
                                                                                    <Text type="secondary">
                                                                                        {log.created_at ? dayjs(log.created_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                                    </Text>
                                                                                </div>
                                                                                <div>
                                                                                    <Text>
                                                                                        Status: {log.response ? (
                                                                                            <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                                                {log.status || 'UNKNOWN'}
                                                                                            </Tag>
                                                                                        ) : (
                                                                                            <Tag color='warning'>UNKNOWN</Tag>
                                                                                        )}
                                                                                    </Text>
                                                                                </div>
                                                                            </>
                                                                        ),
                                                                    },
                                                                    {
                                                                        dot: <CheckCircleOutlined style={{ fontSize: '16px', color: '#52c41a' }} />,
                                                                        children: (
                                                                            <>
                                                                                <Text strong>System → Provider</Text>
                                                                                <div>
                                                                                    <Text type="secondary">
                                                                                        {log.updated_at ? dayjs(log.updated_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                                    </Text>
                                                                                </div>
                                                                                <div>
                                                                                    <Text>
                                                                                        Status: {log.response_adapter ? (
                                                                                            <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                                                {log.status || 'UNKNOWN'}
                                                                                            </Tag>
                                                                                        ) : (
                                                                                            <Tag color='warning'>UNKNOWN</Tag>
                                                                                        )}
                                                                                    </Text>
                                                                                </div>
                                                                            </>
                                                                        ),
                                                                    },
                                                                ]}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            ),
                                        },
                                        {
                                            key: 'result',
                                            label: 'Result',
                                            children: (
                                                <div style={{ width: "100%" }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
                                                        <div>
                                                            <Title level={5}>Result Transaction Data</Title>
                                                            <Text type="secondary">Complete transaction object in JSON format</Text>
                                                        </div>
                                                    </div>

                                                    <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                        <JsonView src={JSON.parse(resultOnDataSponsor)} />
                                                    </div>
                                                </div>
                                            ),
                                        }
                                    ]} />
                                </Card>
                            </div>
                        </>
                    )}
                </div>
            ),
        },
        {
            key: 'pin-code',
            label: 'Pin code',
            children: (
              <div>
                  <Row gutter={24} style={{ marginBottom: 24 }}>
                      <Col span={6}>
                          <Card>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                  <div style={{
                                      width: 40,
                                      height: 40,
                                      borderRadius: 8,
                                      backgroundColor: '#e6f7ff',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                  }}>
                                      <GiftOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                                  </div>
                                  <div>
                                      <Text type="secondary">Total Rules</Text>
                                      <div>
                                          <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                                              {dataCode?.total || 0}
                                          </Title>
                                      </div>
                                  </div>
                              </div>
                          </Card>
                      </Col>
                      <Col span={6}>
                          <Card>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                  <div style={{
                                      width: 40,
                                      height: 40,
                                      borderRadius: 8,
                                      backgroundColor: '#f6ffed',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                  }}>
                                      <GiftOutlined style={{ color: '#52c41a', fontSize: '20px' }} />
                                  </div>
                                  <div>
                                      <Text type="secondary">Active Rules</Text>
                                      <div>
                                          <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                                              {dataCode?.dataCodeModels?.filter((item: any) => item.dataCode)?.length || 0}
                                          </Title>
                                      </div>
                                  </div>
                              </div>
                          </Card>
                      </Col>
                      <Col span={6}>
                          <Card>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                  <div style={{
                                      width: 40,
                                      height: 40,
                                      borderRadius: 8,
                                      backgroundColor: '#fff1f0',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                  }}>
                                      <TeamOutlined style={{ color: '#f5222d', fontSize: '20px' }} />
                                  </div>
                                  <div>
                                      <Text type="secondary">Partners</Text>
                                      <div>
                                          <Title level={3} style={{ margin: 0, color: '#f5222d' }}>
                                              {customers.partners?.length}
                                          </Title>
                                      </div>
                                  </div>
                              </div>
                          </Card>
                      </Col>
                  </Row>
                  <Card style={{ marginBottom: 24 }}>
                      <Row gutter={16}>
                          <Col span={4}>
                              <div style={{ marginBottom: 16 }}>
                                  <Text strong style={{ display: 'block', marginBottom: 8 }}>Chọn đối tác</Text>
                                  <Select
                                    ref={selectCodeRef}
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Chọn khách hàng"
                                    optionFilterProp="name"
                                    onChange={(value) => setSelectedCustomerCode(value)}
                                    filterOption={(input: any, option: any) =>
                                      option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    value={selectedCustomerDataCode}
                                  >
                                      {customers?.partners?.map((customer: any, idx: React.Key) => (
                                        <Select.Option key={idx} value={idx}>
                                            {customer.name}
                                        </Select.Option>
                                      ))}
                                  </Select>
                              </div>
                          </Col>
                          <Col span={4}>
                              <div style={{ marginBottom: 16 }}>
                                  <Text strong style={{ display: 'block', marginBottom: 8 }}>Data Code Serial</Text>
                                  <Input
                                    placeholder="Nhập Data Code Serial"
                                    value={dataCodeSerial}
                                    onChange={(event) => setDataCodeSerial(event.target.value)}
                                    style={{ width: '100%' }}
                                  />
                              </div>
                          </Col>
                          <Col span={4}>
                              <div style={{ marginBottom: 16 }}>
                                  <Text strong style={{ display: 'block', marginBottom: 8 }}>Chọn thời gian</Text>
                                  <DatePicker
                                    allowClear={false}
                                    onChange={onChangeDate}
                                    value={selectedDate}
                                    picker="date"
                                    style={{ width: '100%' }}
                                  />
                              </div>
                          </Col>
                          <Col span={12}>
                              <div style={{ marginBottom: 16 }}>
                                  <Text strong style={{ display: 'block', marginBottom: 8, opacity: 0 }}>Actions</Text>
                                  <Space style={{ width: '100%' }}>
                                      <Button type="primary" onClick={checkDataCode} style={{ flex: 1 }}>
                                          Tìm kiếm
                                      </Button>
                                      <Button danger onClick={clearEventCode} style={{ flex: 1 }} icon={<ReloadOutlined />}>
                                      </Button>
                                  </Space>
                              </div>
                          </Col>
                      </Row>
                  </Card>
                  <Row gutter={16}>
                      {dataCode?.dataCodeModels && dataCode?.dataCodeModels?.length > 0 ? (
                        dataCode?.dataCodeModels?.map((code: any, index: number) => (
                          <Col span={24} key={code.id} style={{ marginBottom: 16 }}>
                              <Card
                                style={{
                                    borderRadius: 8,
                                    border: '1px solid #f0f0f0'
                                }}
                              >
                                  <div style={{ marginBottom: 12 }}>
                                      <Row justify="space-between" align="middle">
                                          <Col span={24}>
                                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                                                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                                      <div style={{
                                                          width: 32,
                                                          height: 32,
                                                          borderRadius: '50%',
                                                          backgroundColor: '#1890ff',
                                                          color: 'white',
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          justifyContent: 'center',
                                                          fontWeight: 'bold',
                                                          fontSize: '12px'
                                                      }}>
                                                          {index + 1}
                                                      </div>
                                                      <div>
                                                          <Title level={5} style={{ margin: 0, marginBottom: 4 }}>
                                                              {code.id}
                                                          </Title>
                                                          <Text type="secondary">
                                                              {code.cpCode}
                                                          </Text>
                                                      </div>
                                                  </div>
                                                  <Text style={{ fontSize: '14px', fontWeight: 500, whiteSpace: 'nowrap' }}>
                                                      <b>Data Code: </b> {code.dataCode}
                                                  </Text>
                                              </div>
                                          </Col>
                                      </Row>
                                  </div>

                                  <Row gutter={16} style={{ marginBottom: 12 }}>
                                      <Col span={4}>
                                          <div>
                                              <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>TRAN ID</Text>
                                              <div style={{ marginTop: 4 }}>
                                                  <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                      {code.tranId}
                                                  </Text>
                                              </div>
                                          </div>
                                      </Col>
                                      <Col span={4}>
                                          <div>
                                              <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>SERIAL</Text>
                                              <div style={{ marginTop: 4 }}>
                                                  <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                      {code.dataCodeSerial}
                                                  </Text>
                                              </div>
                                          </div>
                                      </Col>
                                      <Col span={4}>
                                          <div>
                                              <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>PACKAGE CODE</Text>
                                              <div style={{ marginTop: 4 }}>
                                                  <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                      {code.packageCode}
                                                  </Text>
                                              </div>
                                          </div>
                                      </Col>
                                      <Col span={4}>
                                          <div>
                                              <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>START DATE</Text>
                                              <div style={{ marginTop: 4 }}>
                                                  <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                      {code.startDate}
                                                  </Text>
                                              </div>
                                          </div>
                                      </Col>
                                      <Col span={4}>
                                          <div>
                                              <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>END DATE</Text>
                                              <div style={{ marginTop: 4 }}>
                                                  <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                      {code.endDate}
                                                  </Text>
                                              </div>
                                          </div>
                                      </Col>
                                  </Row>

                                  <div style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      marginTop: 12,
                                      padding: '12px',
                                      backgroundColor: '#fafafa',
                                      borderRadius: 6,
                                      border: '1px solid #f0f0f0'
                                  }}>
                                      <div>
                                          <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>CREATED AT</Text>
                                          <div style={{ marginTop: 4 }}>
                                              <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                  {code.createdAt}
                                              </Text>
                                          </div>
                                      </div>
                                      <Button
                                        key="check"
                                        onClick={() => checkDataCodeOnDataSponsor(code)}
                                        type="primary"
                                        size="small"
                                      >
                                          Kiểm tra
                                      </Button>
                                  </div>
                              </Card>
                          </Col>
                        ))
                      ) : (
                        <Col span={24}>
                            <Card style={{ textAlign: 'center', padding: '40px 20px' }}>
                                <div style={{ color: '#8c8c8c', fontSize: '16px', marginBottom: 16 }}>
                                    <GiftOutlined style={{ fontSize: '48px', marginBottom: 16, display: 'block' }} />
                                    <Title level={4} style={{ color: '#8c8c8c' }}>No Data Codes Found</Title>
                                    <Text type="secondary">
                                        No data code records available. Please search with different criteria.
                                    </Text>
                                </div>
                            </Card>
                        </Col>
                      )}
                  </Row>
                  {resultOnDataSponsor?.length > 0 && (
                    <>
                        <div style={{ width: "100%", marginBottom: 24 }}>
                            <Card>
                                <div style={{ marginBottom: 24 }}>
                                    <Title level={5}>Kết quả kiểm tra của giao dịch {dataCodeSerial}</Title>
                                </div>
                                <Tabs type='card' defaultActiveKey="overview" items={[
                                    {
                                        key: 'overview',
                                        label: 'Overview',
                                        children: (
                                          <div>
                                              <Row gutter={[24, 24]}>
                                                  <Col span={12}>
                                                      <Card>
                                                          <Title level={5} style={{ marginBottom: 16 }}>Transaction Summary</Title>
                                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                              <Text type="secondary">Tran Id</Text>
                                                              <div>
                                                                  <Text strong>{dataCheck.tranId}</Text>
                                                              </div>
                                                          </div>
                                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                              <Text type="secondary">Transaction Id</Text>
                                                              <div>
                                                                  <Text strong>{dataCheck.transactionId}</Text>
                                                              </div>
                                                          </div>
                                                      </Card>
                                                  </Col>
                                                  <Col span={12}>
                                                      <Card>
                                                          <Title level={5} style={{ marginBottom: 16 }}>Fee Breakdown</Title>
                                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                              <Text type="secondary">Package Code</Text>
                                                              <div>
                                                                  <Text strong>{dataCheck.packageCode}</Text>
                                                              </div>
                                                          </div>
                                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                              <Text type="secondary">Value</Text>
                                                              <div>
                                                                  <Text strong>{formatCurrency(dataCheck.value)}</Text>
                                                              </div>
                                                          </div>
                                                      </Card>
                                                  </Col>
                                              </Row>
                                              <Row style={{ marginTop: 20 }} gutter={[24, 24]}>
                                                  <Col span={12}>
                                                      <Card>
                                                          <Title level={5} style={{ marginBottom: 16 }}>Customer Information</Title>
                                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                              <Text type="secondary">Data Code Id</Text>
                                                              <div>
                                                                  <Text strong>{dataCheck.dataCode}</Text>
                                                              </div>
                                                          </div>
                                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                              <Text type="secondary">Data Code</Text>
                                                              <div>
                                                                  <Text strong>{dataCheck.dataCode}</Text>
                                                              </div>
                                                          </div>
                                                      </Card>
                                                  </Col>
                                                  <Col span={12}>
                                                      <Card>
                                                          <Title level={5} style={{ marginBottom: 16 }}>Timeline</Title>
                                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                              <Text type="secondary">CreatedAt</Text>
                                                              <div>
                                                                  <Text strong>{dayjs(dataCheck.createdAt).format('DD/MM/YYYY HH:mm:ss')}</Text>
                                                              </div>
                                                          </div>
                                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                                              <Text type="secondary">UpdatedAt</Text>
                                                              <div>
                                                                  <Text strong>{dayjs(dataCheck.updatedAt).format('DD/MM/YYYY HH:mm:ss')}</Text>
                                                              </div>
                                                          </div>
                                                      </Card>
                                                  </Col>
                                              </Row>
                                          </div>
                                        ),
                                    },
                                    {
                                        key: 'request/response-flow',
                                        label: 'Request/Response Flow',
                                        children: (
                                          <div style={{ width: "100%" }}>
                                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
                                                  <Title level={5}>Request/Response Flow</Title>
                                                  <Tag>{auditLogs?.length * 2} Log Entries</Tag>
                                              </div>
                                              {auditLogs?.length > 0 && auditLogs.map((log: any, index: number) => (
                                                <div key={index} style={{ padding: 12, background: '#f9f9f9', borderRadius: 8, marginBottom: 32 }}>
                                                    <div style={{ marginBottom: 10 }}>
                                                        <b>Response Time</b>: {log.response_time ? `${log.response_time} ms` : 'N/A'}
                                                    </div>
                                                    <Card size='small' style={{ marginBottom: 24, borderRadius: 8 }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                                            <ArrowRightOutlined style={{ color: '#1890ff', marginRight: 8 }} />
                                                            <Text strong>Partner → System</Text>
                                                            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                                                                <Text type="secondary" style={{ marginRight: 8 }}>
                                                                    {log.created_at ? dayjs(log.created_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                </Text>
                                                                {log.response ? (
                                                                  <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                      {log.status || 'UNKNOWN'}
                                                                  </Tag>
                                                                ) : (
                                                                  <Tag color='warning'>UNKNOWN</Tag>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <Collapse
                                                          defaultActiveKey={['response']}
                                                          items={[
                                                              {
                                                                  key: 'request',
                                                                  label: 'Request',
                                                                  children: (
                                                                    <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                        <JsonView src={log.request} />
                                                                    </div>
                                                                  ),
                                                              },
                                                              {
                                                                  key: 'response',
                                                                  label: 'Response',
                                                                  children: (
                                                                    <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                        <JsonView src={log.response} />
                                                                    </div>
                                                                  ),
                                                              },
                                                          ]}
                                                        />
                                                    </Card>

                                                    <Card size='small' style={{ marginBottom: 24, borderRadius: 8 }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                                            <ArrowRightOutlined style={{ color: '#1890ff', marginRight: 8 }} />
                                                            <Text strong>System → Provider</Text>
                                                            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                                                                <Text type="secondary" style={{ marginRight: 8 }}>
                                                                    {log.updated_at ? dayjs(log.updated_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                </Text>
                                                                {log.response_adapter ? (
                                                                  <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                      {log.status || 'UNKNOWN'}
                                                                  </Tag>
                                                                ) : (
                                                                  <Tag color='warning'>UNKNOWN</Tag>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <Collapse
                                                          defaultActiveKey={['response', 'error']}
                                                          items={[
                                                              {
                                                                  key: 'request',
                                                                  label: 'Request',
                                                                  children: (
                                                                    <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                        <JsonView src={log.request_adapter} />
                                                                    </div>
                                                                  ),
                                                              },
                                                              log.response_adapter ? {
                                                                  key: 'response',
                                                                  label: 'Response',
                                                                  children: (
                                                                    <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                                        <JsonView src={log.response_adapter} />
                                                                    </div>
                                                                  ),
                                                              } : {
                                                                  key: 'error',
                                                                  label: 'Error',
                                                                  children: (
                                                                    <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4, overflowWrap: 'break-word' }}>
                                                                        {log.error}
                                                                    </div>
                                                                  ),
                                                              },
                                                          ]}
                                                        />
                                                    </Card>
                                                </div>
                                              ))}
                                          </div>
                                        ),
                                    },
                                    {
                                        key: 'timeline',
                                        label: 'Timeline',
                                        children: (
                                          <div style={{ width: "100%" }}>
                                              <div style={{ marginBottom: 32 }}>
                                                  <Title level={5}>Transaction Timeline</Title>
                                                  <Text type="secondary">Complete timeline of transaction events and state changes</Text>
                                              </div>
                                              {auditLogs?.length > 0 && auditLogs.map((log: any, index: number) => (
                                                <div key={index} style={{ marginBottom: 32 }}>
                                                    <div style={{ marginBottom: 16 }}>
                                                        <b>Response Time</b>: {log.response_time ? `${log.response_time} ms` : 'N/A'}
                                                    </div>
                                                    <Timeline
                                                      items={[
                                                          {
                                                              dot: <ClockCircleOutlined style={{ fontSize: '16px' }} />,
                                                              children: (
                                                                <>
                                                                    <Text strong>Transaction Created</Text>
                                                                    <div>
                                                                        <Text type="secondary">
                                                                            {log.created_at ? dayjs(log.created_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                        </Text>
                                                                    </div>
                                                                    <div>
                                                                        <Text>IP Address: {log.ip_address}</Text>
                                                                    </div>
                                                                </>
                                                              ),
                                                          },
                                                          {
                                                              dot: <CheckCircleOutlined style={{ fontSize: '16px', color: '#52c41a' }} />,
                                                              children: (
                                                                <>
                                                                    <Text strong>Partner → System</Text>
                                                                    <div>
                                                                        <Text type="secondary">
                                                                            {log.created_at ? dayjs(log.created_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                        </Text>
                                                                    </div>
                                                                    <div>
                                                                        <Text>
                                                                            Status: {log.response ? (
                                                                          <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                              {log.status || 'UNKNOWN'}
                                                                          </Tag>
                                                                        ) : (
                                                                          <Tag color='warning'>UNKNOWN</Tag>
                                                                        )}
                                                                        </Text>
                                                                    </div>
                                                                </>
                                                              ),
                                                          },
                                                          {
                                                              dot: <CheckCircleOutlined style={{ fontSize: '16px', color: '#52c41a' }} />,
                                                              children: (
                                                                <>
                                                                    <Text strong>System → Provider</Text>
                                                                    <div>
                                                                        <Text type="secondary">
                                                                            {log.updated_at ? dayjs(log.updated_at).locale('en').format("MMM DD, YYYY, hh:mm:ss A") : 'N/A'}
                                                                        </Text>
                                                                    </div>
                                                                    <div>
                                                                        <Text>
                                                                            Status: {log.response_adapter ? (
                                                                          <Tag color={log.status === 'SUCCESS' ? 'success' : 'error'}>
                                                                              {log.status || 'UNKNOWN'}
                                                                          </Tag>
                                                                        ) : (
                                                                          <Tag color='warning'>UNKNOWN</Tag>
                                                                        )}
                                                                        </Text>
                                                                    </div>
                                                                </>
                                                              ),
                                                          },
                                                      ]}
                                                    />
                                                </div>
                                              ))}
                                          </div>
                                        ),
                                    },
                                    {
                                        key: 'result',
                                        label: 'Result',
                                        children: (
                                          <div style={{ width: "100%" }}>
                                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
                                                  <div>
                                                      <Title level={5}>Result Transaction Data</Title>
                                                      <Text type="secondary">Complete transaction object in JSON format</Text>
                                                  </div>
                                              </div>

                                              <div style={{ backgroundColor: '#f9f9f9', padding: 16, borderRadius: 4 }}>
                                                  <JsonView src={JSON.parse(resultOnDataSponsor)} />
                                              </div>
                                          </div>
                                        ),
                                    }
                                ]} />
                            </Card>
                        </div>
                    </>
                  )}
              </div>
            ),
        },
        {
            key: 'refund',
            label: 'Refund',
            children: (
                <div>
                    <Row gutter={24} style={{ marginBottom: 24 }}>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#e6f7ff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TransactionOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Total Rules</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                                                {tranRefund?.total || 0}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#f6ffed',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TransactionOutlined style={{ color: '#52c41a', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Active Rules</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                                                {tranRefund?.listTrans?.filter((item: any) => item.return === 'Refund')?.length || 0}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 8,
                                        backgroundColor: '#fff1f0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <TeamOutlined style={{ color: '#f5222d', fontSize: '20px' }} />
                                    </div>
                                    <div>
                                        <Text type="secondary">Partners</Text>
                                        <div>
                                            <Title level={3} style={{ margin: 0, color: '#f5222d' }}>
                                                {customers.partners?.length}
                                            </Title>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Card style={{ marginBottom: 24 }}>
                        <Row gutter={16}>
                            <Col span={4}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Chọn đối tác</Text>
                                    <Select
                                        ref={selectRefundRef}
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder="Chọn khách hàng"
                                        optionFilterProp="name"
                                        onChange={(value) => setSelectedCustomerRefund(value)}
                                        filterOption={(input: any, option: any) =>
                                            option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        value={selectedCustomerDataRefund}
                                    >
                                        {customers?.partners?.map((customer: any, idx: React.Key) => (
                                            <Select.Option key={idx} value={idx}>
                                                {customer.name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>
                            </Col>
                            <Col span={4}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Thời gian</Text>
                                    <DatePicker
                                        allowClear={false}
                                        onChange={value => setTimeRefund(dayjs(value, 'YYYY-MM'))}
                                        value={timeRefund}
                                        format={'YYYY-MM'}
                                        picker="month"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </Col>
                            <Col span={16}>
                                <div style={{ marginBottom: 16 }}>
                                    <Text strong style={{ display: 'block', marginBottom: 8, opacity: 0 }}>Actions</Text>
                                    <Space style={{ width: '100%' }}>
                                        <Button type="primary" onClick={checkRefund} style={{ flex: 1 }}>
                                            Tìm kiếm
                                        </Button>
                                        <Button danger onClick={clearEventCode} style={{ flex: 1 }} icon={<ReloadOutlined />}>
                                        </Button>
                                    </Space>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                    <Row gutter={16}>
                        {tranRefund?.listTrans && tranRefund?.listTrans?.length > 0 ? (
                            tranRefund?.listTrans?.map((refund: any, index: number) => (
                                <Col span={24} key={refund.id} style={{ marginBottom: 16 }}>
                                    <Card
                                        style={{
                                            borderRadius: 8,
                                            border: '1px solid #f0f0f0'
                                        }}
                                    >
                                        <div style={{ marginBottom: 12 }}>
                                            <Row justify="space-between" align="middle">
                                                <Col span={24}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                                            <div style={{
                                                                width: 32,
                                                                height: 32,
                                                                borderRadius: '50%',
                                                                backgroundColor: '#1890ff',
                                                                color: 'white',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontWeight: 'bold',
                                                                fontSize: '12px'
                                                            }}>
                                                                {index + 1}
                                                            </div>
                                                            <div>
                                                                <Title level={5} style={{ margin: 0, marginBottom: 4 }}>
                                                                    {refund.id}
                                                                </Title>
                                                                <Text type="secondary">
                                                                    {refund.cpCode}
                                                                </Text>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <Text style={{ fontSize: '14px', fontWeight: 500, whiteSpace: 'nowrap' }}>
                                                                <b>TranId </b> {refund.tranId}
                                                            </Text>
                                                            <div style={{ textAlign: 'right', marginTop: 10 }}>
                                                                {refund.return === 'Refund' && (
                                                                    <span style={{
                                                                        padding: '4px 8px',
                                                                        backgroundColor: '#ff4d4f',
                                                                        color: 'white',
                                                                        borderRadius: 4,
                                                                        fontSize: '12px',
                                                                        fontWeight: 'bold',
                                                                    }}>
                                                                        REFUNDED
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>

                                        <Row gutter={16} style={{ marginBottom: 12 }}>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>PLATFORM</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {refund.platform}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>MSISDN</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {refund.msisdn}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>PRICE</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {formatCurrency(refund.price)}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row gutter={16} style={{ marginBottom: 12 }}>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>PACKAGE NAME</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {refund.packageName}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>DATA PACK</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {refund.dataPack}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>REQ TIME</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {dayjs(refund.reqTime).format("YYYY-MM-DD HH:mm:ss")}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={4}>
                                                <div>
                                                    <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>TYPE</Text>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                                            {refund.type}
                                                        </Text>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col span={24}>
                                <Card style={{ textAlign: 'center', padding: '40px 20px' }}>
                                    <div style={{ color: '#8c8c8c', fontSize: '16px', marginBottom: 16 }}>
                                        <TransactionOutlined style={{ fontSize: '48px', marginBottom: 16, display: 'block' }} />
                                        <Title level={4} style={{ color: '#8c8c8c' }}>No Refund Records Found</Title>
                                        <Text type="secondary">
                                            No refund transaction records available for the selected period.
                                        </Text>
                                    </div>
                                </Card>
                            </Col>
                        )}
                    </Row>
                </div>
            ),
        },
    ];
    const onChange = (key: string) => {
        clearEvent()
        clearEventCode()
    };

    return <div>
        <Tabs defaultActiveKey="data-sponsor" items={itemsTab} onChange={onChange}></Tabs>
        <Modal title='Refund sponsor' open={modalSponsor.isOpen}
            onCancel={() => {
                setModalSponsor({ data: null, isOpen: false })
                setConfirmCode('')
            }}
            footer={[
                <Button onClick={handleRefundTransaction} type='primary'>
                    Refund
                </Button>,
            ]}>
            <div style={{ marginBottom: 20 }}>
                Bạn có chắc muốn hoàn trả tiền giao dịch <b>{modalSponsor.data?.tranId}</b> cho đối tác <b>{modalSponsor.data?.cpCode}</b>?
            </div>
            <Input value={cofirmCode} onChange={e => setConfirmCode(e.target.value)} />
        </Modal>
    </div>
}
